// audio-controller.ts
export interface GlobalAudioState {
  audioRef: HTMLAudioElement | null;
  setIsPlaying: ((playing: boolean) => void) | null;
}

const MainglobalAudioState: GlobalAudioState = {
  audioRef: null,
  setIsPlaying: null,
};

export default MainglobalAudioState;
